import type {
  Ingredient,
  IngredientOption,
  Locale,
  RecipeFamily,
  RecipeStep,
} from "./types";

export function localizedIngredientName(
  ingredient: Ingredient,
  locale: Locale,
): string {
  if (locale === "tr" && ingredient.translations) {
    return ingredient.translations.tr.name;
  }
  return ingredient.name;
}

export function localizedPreparation(
  option: IngredientOption,
  locale: Locale,
): string | undefined {
  if (locale === "tr" && option.translations?.tr.preparation !== undefined) {
    return option.translations.tr.preparation;
  }
  return option.preparation;
}

export function localizedNameTemplate(
  recipe: RecipeFamily,
  locale: Locale,
): string {
  if (locale === "tr" && recipe.translations) {
    return recipe.translations.tr.nameTemplate;
  }
  return recipe.nameTemplate;
}

export function localizedStepTemplate(
  step: RecipeStep,
  locale: Locale,
): string {
  if (locale === "tr" && step.translations) {
    return step.translations.tr.template;
  }
  return step.template;
}

export function localizedInstructionValue(
  option: IngredientOption,
  field: string,
  locale: Locale,
): string | undefined {
  if (locale === "tr") {
    const trValue = option.translations?.tr.instructionValues?.[field];
    if (trValue !== undefined) return trValue;
  }
  return option.instructionValues?.[field];
}
